var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c("div", { staticClass: "top" }, [_vm._v("实名认证")]),
      _vm._v(" "),
      _vm.step == 1
        ? [
            _c("div", { staticClass: "panel" }, [
              _c("div", { staticClass: "title-1" }, [
                _vm._v("1、请上传二代身份证")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title-2" }, [
                _vm._v("请确保上传本人清晰、完整、有效的身份证")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "upload-box" }, [
                _c(
                  "div",
                  { staticClass: "box-item" },
                  [
                    _c(
                      "van-uploader",
                      {
                        staticClass: "img",
                        attrs: { "after-read": _vm.afterReadFront }
                      },
                      [
                        _vm.fileForm.front
                          ? _c("img", {
                              staticClass: "idcard",
                              attrs: { src: _vm.fileForm.front.content }
                            })
                          : _c("img", {
                              staticClass: "idcard",
                              attrs: {
                                src: require("../assets/newimg/guohui.png")
                              }
                            }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../assets/newimg/shangchuan.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [_vm._v("上传人像面")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box-item" },
                  [
                    _c(
                      "van-uploader",
                      {
                        staticClass: "img",
                        attrs: { "after-read": _vm.afterReadBack }
                      },
                      [
                        _vm.fileForm.back
                          ? _c("img", {
                              staticClass: "idcard",
                              attrs: { src: _vm.fileForm.back.content }
                            })
                          : _c("img", {
                              staticClass: "idcard",
                              attrs: {
                                src: require("../assets/newimg/guohui.png")
                              }
                            }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../assets/newimg/shangchuan.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [_vm._v("上传国徽面")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "step", on: { click: _vm.netStep } }, [
                _vm._v("下一步")
              ])
            ])
          ]
        : [
            _c("div", { staticClass: "panel" }, [
              _c("div", { staticClass: "title-1" }, [
                _vm._v("2、请完成手机验证")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "phone-form" }, [
                _c("div", { staticClass: "input-control" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("手机号")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.mobile,
                        expression: "ruleForm.mobile"
                      }
                    ],
                    attrs: { placeholder: "请输入您的11位手机号码" },
                    domProps: { value: _vm.ruleForm.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "mobile", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-control" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("验证码")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.code,
                        expression: "ruleForm.code"
                      }
                    ],
                    domProps: { value: _vm.ruleForm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "code", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "addon", on: { click: _vm.handleSms } },
                    [_vm._v(_vm._s(_vm.smsBtnTxt))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "return-btn",
                    on: {
                      click: function($event) {
                        _vm.step = 1
                      }
                    }
                  },
                  [_vm._v("上一步")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "submit", on: { click: _vm.submit } },
                  [_vm._v("提交")]
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "tips-item" }, [
        _c("img", { attrs: { src: require("../assets/newimg/cuowu.png") } }),
        _vm._v(" "),
        _c("span", [_vm._v("边框缺失")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tips-item" }, [
        _c("img", { attrs: { src: require("../assets/newimg/cuowu.png") } }),
        _vm._v(" "),
        _c("span", [_vm._v("照片模糊")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tips-item" }, [
        _c("img", { attrs: { src: require("../assets/newimg/cuowu.png") } }),
        _vm._v(" "),
        _c("span", [_vm._v("反光强烈")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db71058a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db71058a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/authpage.vue
// module id = null
// module chunks = 